/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2023 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
export const notImplemented=()=>new Error("Not implemented");export const unexpectedData=e=>e?new Error(`Unexpected data: "${e}"`):new Error("Unexpected data");export const unsupportedData=e=>e?new Error(`Unsupported data: "${e}"`):new Error("Unsupported data");export const invalidData=e=>e?new Error(`Invalid data: "${e}"`):new Error("Invalid data");export const unexpectedState=()=>new Error("Unexpected state");